<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>灰度设置</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Form-item label="所有学生">
          <i-switch :value="allEnabled === 1" size="large" :disabled="saving" @on-change="onAllChange">
            <span slot="open">开</span>
            <span slot="close">关</span>
          </i-switch>
        </Form-item>
        <p v-if="allEnabled === 1" class="mex-dim-hint">全量已开，名单不参与判定</p>
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="adviserId"></admin-user-select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label=" ">
              <Button type="primary" :loading="saving" @click="addAdviser">添加学导</Button>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="销售">
              <admin-user-select :status="1" adminGroupCode="adviser" v-model="sellerId"></admin-user-select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label=" ">
              <Button type="primary" :loading="saving" @click="addSeller">添加销售</Button>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="学生ID或手机号">
              <Input v-model="studentKeyword" placeholder="输入学生 uid 或手机号"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label=" ">
              <Button type="primary" :loading="saving" @click="addStudent">添加学生</Button>
            </Form-item>
          </i-col>
        </Row>
      </Form>
    </div>
    <h4 class="mex-gray-title">学导</h4>
    <Table :columns="ruleColumns" :data="advisers" size="small"></Table>
    <h4 class="mex-gray-title">销售</h4>
    <Table :columns="ruleColumns" :data="sellers" size="small"></Table>
    <h4 class="mex-gray-title">指定学生</h4>
    <Table :columns="ruleColumns" :data="students" size="small"></Table>
  </div>
</template>

<script>
export default {
  name: 'MexGraySetting',
  data () {
    return {
      saving: false,
      allEnabled: 0,
      adviserId: null,
      sellerId: null,
      studentKeyword: '',
      advisers: [],
      sellers: [],
      students: [],
      ruleColumns: [
        { title: 'ID', key: 'id', width: 90, ellipsis: true },
        {
          title: '名称',
          key: 'targetName',
          minWidth: 180,
          ellipsis: true,
          render: (h, params) => h('span', params.row.targetName || params.row.name || '—')
        },
        { title: 'targetId', key: 'targetId', width: 140, ellipsis: true },
        {
          title: '操作',
          key: 'action',
          width: 100,
          render: (h, params) => {
            return h('Button', {
              props: { type: 'error', size: 'small' },
              on: { click: () => this.remove(params.row.id) }
            }, '删除')
          }
        }
      ]
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.$http.post('/mex/gray/get').then(res => {
        if (res.status === 'ok') {
          let d = res.data || {}
          this.allEnabled = d.allEnabled === true || d.allEnabled === 1 || d.allEnabled === '1' ? 1 : 0
          this.advisers = d.advisers || []
          this.sellers = d.sellers || []
          this.students = d.students || []
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    onAllChange (on) {
      this.saving = true
      this.$http.post('/mex/gray/saveAll', { enabled: on ? 1 : 0 }).then(res => {
        this.saving = false
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.load()
        } else {
          this.$Message.error(res.msg || '保存失败')
          this.load()
        }
      }).catch(() => {
        this.saving = false
        this.$Message.error('保存失败')
        this.load()
      })
    },
    addAdviser () {
      if (!this.adviserId) {
        this.$Message.error('请选择学导')
        return
      }
      this.addRule({ scope: 'ADVISER', targetId: this.adviserId }, () => {
        this.adviserId = null
      })
    },
    addSeller () {
      if (!this.sellerId) {
        this.$Message.error('请选择销售')
        return
      }
      this.addRule({ scope: 'SELLER', targetId: this.sellerId }, () => {
        this.sellerId = null
      })
    },
    addStudent () {
      let keyword = (this.studentKeyword || '').trim()
      if (!keyword) {
        this.$Message.error('请输入学生ID或手机号')
        return
      }
      let payload = { scope: 'UID', keyword: keyword }
      if (/^\d+$/.test(keyword)) {
        payload.targetId = keyword
      }
      this.addRule(payload, () => {
        this.studentKeyword = ''
      })
    },
    addRule (payload, onOk) {
      this.saving = true
      this.$http.post('/mex/gray/add', payload).then(res => {
        this.saving = false
        if (res.status === 'ok') {
          this.$Message.success('已添加')
          if (onOk) onOk()
          this.load()
        } else {
          this.$Message.error(res.msg || '添加失败')
        }
      }).catch(() => {
        this.saving = false
        this.$Message.error('添加失败')
      })
    },
    remove (id) {
      if (!id) return
      this.saving = true
      this.$http.post('/mex/gray/remove', { id: id }).then(res => {
        this.saving = false
        if (res.status === 'ok') {
          this.$Message.success('已删除')
          this.load()
        } else {
          this.$Message.error(res.msg || '删除失败')
        }
      }).catch(() => {
        this.saving = false
        this.$Message.error('删除失败')
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-gray-title {
  margin: 16px 0 8px;
}

.mex-dim-hint {
  color: #808695;
  font-size: 12px;
  line-height: 20px;
  margin: 0 0 12px;
}
</style>



// WEBPACK FOOTER //
// MexGraySetting.vue?15593900